import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modal_video_body:{
        maxWidth: '58.75rem',
        width: '100%',
        height: '100%',
        margin: '0 auto',
        display: 'table',
        outline: 'none'
    },
    modal_video_inner:{
        display: 'table-cell',
        verticalAlign: 'middle',
        width: '100%',
        height: '100%'
    },
    modal_video_movie_wrap:{
        width: '100%',
        height: 0,
        position: 'relative',
        backgroundColor: '#333'
    },
    video_frame:{
        position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%'
    },
    close_button:{
        position: 'absolute',
        top: '-2.375rem',
        right: '0',
        display: 'inline-block',
        padding: '0.25rem',
        overflow: 'hidden',
        border: 'none',
        backgroundColor: 'transparent'
    },
    button_icon:{
        display: 'block',
        height: '1.875rem',
        width: '1.875rem',
        color: theme.palette.white,
    }
}));
